import { __assign } from "tslib";
import React, { useState, useMemo } from "react";
import moment from "moment";
import { Grid, Switch, FormControlLabel, makeStyles } from "@material-ui/core";
import { useConfigs } from "../config-provider";
import TimeList from "./TimeList";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: theme.spacing(1, 2)
    },
    input: {
      "&>div": {
        paddingRight: 0
      }
    }
  };
});

function getTime(hour, minutes) {
  return "".concat(String(hour >= 12 ? hour - 12 : hour).padStart(2, "0"), ":").concat(String(minutes).padStart(2, "0"), " ").concat(hour >= 12 ? "PM" : "AM");
}

var options = Array(48).fill(null).map(function (_, index) {
  var hour = Math.floor(index / 2);
  var minutes = index % 2 === 0 ? 0 : 30;
  var now = moment();
  now.hours(hour);
  now.minutes(minutes);
  return {
    value: now,
    label: getTime(hour, minutes),
    disabled: false
  };
});

var TimeRange = function TimeRange(_a) {
  var timeRange = _a.timeRange,
      _b = _a.isOneDay,
      isOneDay = _b === void 0 ? false : _b,
      onChange = _a.onChange,
      onClear = _a.onClear;
  var locale = useConfigs().locale;
  var classes = useStyles();

  var _c = useState(!(timeRange.every(function (item) {
    return item === null;
  }) || timeRange[0] !== null && timeRange[0].format("HH:mm") === "00:00" && timeRange[1] !== null && timeRange[1].format("HH:mm") === "23:59")),
      checked = _c[0],
      setChecked = _c[1];

  function getNumber(v) {
    return v.hours() * 60 + v.minutes();
  }

  var startOptions = useMemo(function () {
    if (!isOneDay || !timeRange[1]) {
      return options;
    } else {
      return options.map(function (item) {
        return getNumber(item.value) > getNumber(timeRange[1]) ? __assign(__assign({}, item), {
          disabled: true
        }) : item;
      });
    }
  }, [isOneDay, timeRange[1]]);
  var endOptions = useMemo(function () {
    if (!isOneDay || !timeRange[0]) {
      return options;
    }

    return options.map(function (item) {
      return getNumber(item.value) < getNumber(timeRange[0]) ? __assign(__assign({}, item), {
        disabled: true
      }) : item;
    });
  }, [isOneDay, timeRange[0]]);
  return React.createElement(Grid, {
    className: classes.root
  }, React.createElement(Grid, {
    style: {
      marginBottom: 8
    }
  }, React.createElement(FormControlLabel, {
    control: React.createElement(Switch, {
      checked: checked,
      onChange: function onChange(e) {
        setChecked(e.target.checked);

        if (!e.target.checked) {
          onClear();
        }
      },
      color: "primary",
      name: "checkedA"
    }),
    label: locale.DateRange.time
  })), checked && React.createElement(Grid, {
    container: true
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(TimeList, {
    label: locale.DateRange.startTime,
    options: startOptions,
    value: timeRange[0],
    onChange: onChange("startDateTime")
  })), React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(TimeList, {
    label: locale.DateRange.endTime,
    options: endOptions,
    value: timeRange[1],
    onChange: onChange("endDateTime")
  }))));
};

export default TimeRange;